// GÉNÉRÉ par `scripts/ingest/refresh-finess-categories.ts` — NE PAS ÉDITER À LA MAIN.
// Nomenclature officielle TRE_R397 « catégorie d'entité géographique d'exercice »
// (serveur multi-terminologies ANS), figée dans le repo : l'ingestion FINESS et la
// lib publiée doivent rester déterministes et hors-ligne. Ordre = réponse SMT.
// @generated-count 428
// source https://smt.esante.gouv.fr/fhir/CodeSystem/tre-r397-categorie-entite-geographique-exercice

/** Date de la dernière régénération — exposée à l'ingestion (âge de la nomenclature). */
export const FINESS_CATEGORIE_LABELS_REFRESHED_AT = "2026-09-05T20:44:57.870Z";

/** code TRE_R397 → libellé officiel (428 concepts au 2026-09-05). */
export const SMT_CATEGORIE_LABELS = {
  "101": "Centre Hospitalier Régional (C.H.R.)",
  "106": "Centre hospitalier, ex Hôpital local",
  "108": "Etablissement de Convalescence et de Repos",
  "109": "Etablissement de santé privé autorisé en SSR",
  "112": "Centre de Convalescence Cure ou Réadaptation",
  "114": "Hôpital des armées",
  "115": "Etablissement de Soins du Service de Santé des Armées",
  "119": "Maison de Régime",
  "122": "Etablissement Soins Obstétriques Chirurgico-Gynécologiques",
  "124": "Centre de Santé",
  "125": "Centre de Santé Dentaire",
  "126": "Etablissement Thermal",
  "127": "Hospitalisation à Domicile",
  "128": "Etablissement de Soins Chirurgicaux",
  "129": "Etablissement de Soins Médicaux",
  "130": "Centre de Soins Médicaux",
  "131": "Centre de Lutte Contre Cancer",
  "132": "Etablissement de Transfusion Sanguine",
  "135": "Etablissement Réadaptation Fonctionnelle",
  "136": "Banque de Sperme",
  "137": "Banque d'Organes",
  "138": "Centre de Dialyse Périodique",
  "139": "Centre de Dialyse et d'entraînement à la Dialyse",
  "140": "Centre d'Entraînement à la Dialyse",
  "141": "Centre de dialyse",
  "142": "Dispensaire Antituberculeux",
  "143": "Centre de Vaccination BCG",
  "144": "Etablissement de Lutte Contre la Tuberculose",
  "146": "Structure d'Alternative à la dialyse en centre",
  "156": "Centre Médico-Psychologique (C.M.P.)",
  "157": "Centre de Postcure",
  "159": "Centre Parental",
  "160": "Centre de Soins Spécifiques pour Toxicomanes (C.S.S.T.)",
  "161": "Maison de Santé pour Maladies Mentales",
  "162": "Centre de Cure Ambulatoire en Alcoologie (C.C.A.A.)",
  "163": "Maison d'Enfants à Caractère Sanitaire Temporaire",
  "164": "Etablissements Expérimentaux Accueil de la Petite Enfance",
  "165": "Appartement de Coordination Thérapeutique (A.C.T.)",
  "166": "Centre Parents-Enfants de moins de 3 ans",
  "167": "Crèche Collective",
  "168": "Service Accueil Familial pour la Petite Enfance",
  "169": "Crèche Multi Accueil Collectif et Familial",
  "170": "Halte Garderie",
  "171": "Garderie et Jardin d'Enfants",
  "172": "Pouponnière à Caractère Social",
  "173": "Pouponnière à Caractère Sanitaire",
  "174": "Etablissement d'Accueil Collectif Régulier et Occasionnel",
  "175": "Foyer de l'Enfance",
  "176": "Village d'Enfants",
  "177": "Maison d'Enfants à Caractère Social",
  "178": "Ctre.Accueil- Accomp.Réduc.Risq.Usag. Drogues (C.A.A.R.U.D.)",
  "179": "Maison d'Enfants à Caractère Sanitaire Permanente",
  "180": "Lits Halte Soins Santé (L.H.S.S.)",
  "181": "Maison Familiale de Vacances",
  "182": "Service d'Éducation Spéciale et de Soins à Domicile",
  "183": "Institut Médico-Educatif (I.M.E.)",
  "184": "Institut Médico-Pédagogique (I.M.P.)",
  "185": "Institut Médico-Professionnel (I.M.Pro.)",
  "186": "Institut Thérapeutique Éducatif et Pédagogique (I.T.E.P.)",
  "188": "Etablissement pour Enfants ou Adolescents Polyhandicapés",
  "189": "Centre Médico-Psycho-Pédagogique (C.M.P.P.)",
  "190": "Centre Action Médico-Sociale Précoce (C.A.M.S.P.)",
  "191": "Etablissement pour Déficients Moteurs Cérébraux",
  "192": "Institut d'éducation motrice",
  "193": "Etablissement pour Déficients Moteurs et Moteurs Cérébraux",
  "194": "Institut pour Déficients Visuels",
  "195": "Institut pour Déficients Auditifs",
  "196": "Institut d'Education Sensorielle Sourd-Aveugle",
  "197": "Centre soins accompagnement prévention addictologie (CSAPA)",
  "198": "Établissement et Service de Préorientation",
  "199": "Hospice",
  "200": "Maison de Retraite",
  "202": "Résidences autonomie",
  "205": "Foyer Club Restaurant",
  "207": "Centre de Jour pour Personnes Agées",
  "208": "Service d'Aide Ménagère à Domicile",
  "209": "Service autonomie aide et soins (SAAS)",
  "212": "Alarme Médico-Sociale",
  "213": "Lits d'Accueil Médicalisés (L.A.M.)",
  "214": "Centre Hébergement & Réinsertion Sociale (C.H.R.S.)",
  "215": "Maison Relai",
  "216": "Résidence Hôtelière à Vocation Sociale (R.H.V.S)",
  "217": "Cité de Transit",
  "218": "Aire Station Nomades",
  "219": "Autre Centre d'Accueil",
  "220": "Centre Social",
  "221": "Bureau d'Aide Psychologique Universitaire (B.A.P.U.)",
  "223": "Protection Maternelle et Infantile (P.M.I.)",
  "224": "Etablissement de Consultation Pré et Post-natale",
  "225": "Consultations de Nourrissons",
  "228": "Centre de Santé Sexuelle",
  "229": "Consultation Problèmes naissance",
  "230": "Etablissement Consultation Protection Infantile",
  "231": "Espaces de vie affective, relationnelle et sexuelle (EVARS)",
  "233": "Lactarium",
  "236": "Service de placement familial",
  "237": "Centre de Placement Familial Spécialisé",
  "238": "Centre d'Accueil Familial Spécialisé",
  "241": "Établissement de Placement",
  "242": "Service d’Activité de Jour",
  "246": "Etablissement et Service d'Aide par le Travail (E.S.A.T.)",
  "247": "Entreprise adaptée",
  "249": "Établissement et Service de Réadaptation Professionnelle",
  "250": "Centre Réentrainement au travail",
  "251": "Maison Vacances pour Handicapés",
  "252": "Foyer Hébergement Adultes Handicapés",
  "253": "Foyer d'Accueil Polyvalent pour Adultes Handicapés",
  "255": "Maison d'Accueil Spécialisée (M.A.S.)",
  "256": "Foyer Travailleurs Migrants non transformé en Résidence Soc.",
  "257": "Foyers de jeunes travailleurs",
  "258": "Maisons Relais - Pensions de Famille",
  "259": "Autres résidences sociales",
  "261": "D.D.A.S.S.",
  "262": "Etablissement Régional d'Enseignement Adapté",
  "265": "Section Education Spéciale Classe Atelier",
  "266": "Dispensaire Antivénérien",
  "267": "Dispensaire Antihansénien",
  "268": "Centre Médico-Scolaire",
  "269": "Centre de Médecine Universitaire",
  "270": "Centre de Médecine Sportive",
  "271": "Maison d'accueil Hospitalière",
  "272": "Ecole d'ambulanciers",
  "273": "Institut de formation en soins infirmiers (I.F.S.I.)",
  "274": "Ecole de sages_femmes",
  "275": "Ecole de masseurs-kinésithérapeutes",
  "276": "Ecole de laborantins d'analyses médicales",
  "277": "Ecole de péricultrices",
  "278": "Etablissement de formation polyvalent",
  "279": "Ecole de service social",
  "280": "Ecole d'éducateurs spécialisés",
  "281": "Centre de formation d'aides soignants",
  "282": "Ecole de pédicures-podologues",
  "283": "Ecole de manipulateurs d'électro-radiologie",
  "284": "Ecole de travailleuses familiales",
  "285": "Centres de Loisirs sans Hébergement",
  "286": "Service de prévention spécialisée",
  "289": "Centre de Soins Infirmiers",
  "292": "Centre Hospitalier Spécialisé lutte Maladies Mentales",
  "294": "Centre de Consultations Cancer",
  "295": "Service AEMO et AED",
  "297": "Dispensaire Polyvalent",
  "300": "Ecoles Formant aux Professions Sanitaires",
  "303": "Ecole de conseillers en économie sociale et familiale",
  "304": "Ecole d'ergothérapeutes",
  "305": "Ecole de psycho-motriciens",
  "306": "Ecole d'infirmiers anesthésistes",
  "307": "Ecole d'infirmiers de bloc opératoire",
  "308": "Centre de formation professionnelle de secteur psychiatrique",
  "309": "Ecole de cadres infirmiers",
  "310": "Ecole de cadres de secteur psychiatrique",
  "311": "Ecole de cadres de masseurs-kinésithérapeutes",
  "312": "Ecole de cadres de manipulateurs d'électro-radiologie",
  "313": "Ecole d'éducateurs de jeunes enfants",
  "314": "Ecole d'éducateurs techniques spécialisés",
  "315": "Ecole de moniteurs-éducateurs",
  "316": "Ecole d'aides médico-psychologiques",
  "317": "Ecole d'animateurs socio-éducatifs",
  "319": "Inst. régional de formation des travailleurs sociaux",
  "320": "S.A.M.U. et Centre 15",
  "321": "Unité Mobile Hospitalière",
  "322": "Centre Rég.Informatiq.Hospit.",
  "324": "Logement Foyer non Spécialisé",
  "326": "Ecole de cadres",
  "327": "Service d'Ambulances",
  "328": "Centre Consultation Soins Dentaire",
  "329": "Sectorisation Psychiatrique",
  "330": "Ecoles Formant aux Professions Sociales",
  "340": "Service mandataire judiciaire à la protection des majeurs",
  "341": "Service dédié mesures d'accompagnement social personnalisé",
  "342": "Service d'information et de soutien aux tuteurs familiaux",
  "343": "Equipe Préparation et Suite Reclassement (EPSR)",
  "344": "Service délégué aux prestations familiales",
  "345": "Service Tutelle Prestation Sociale",
  "346": "Service de Travailleuses Familiales",
  "347": "Centre d'Examens de Santé",
  "349": "Ecole de cadres de sages-femmes",
  "350": "Centre de formation d'auxiliaires de puériculture",
  "352": "Centre de Psychothérapie",
  "353": "Hôpital de Jour Spécialités Médicales",
  "354": "Service de Soins Infirmiers A Domicile (S.S.I.A.D)",
  "355": "Centre Hospitalier (C.H.)",
  "357": "Association Aide aux Insuffisants Respiratoires",
  "359": "Centre Circonscription Sanitaire et Sociale",
  "361": "Centre de Cure Médicale",
  "362": "Etablissement de Soins Longue Durée",
  "363": "Centre moyen et long séjour",
  "365": "Etablissement de Soins Pluridisciplinaire",
  "366": "Atelier Thérapeutique",
  "367": "Maison d'Enfants non Conventionnée ni Habilitée",
  "368": "Service de Repas à Domicile",
  "369": "Centre Adaptation Vie Active (C.A.V.A.)",
  "370": "Etablissement Expérimental pour personnes handicapées",
  "371": "Service Action Socio-Educative pour Familles en difficulté",
  "373": "Centre de formation supérieure des travailleurs sociaux",
  "374": "Ecole Nationale Santé Publique (E.N.S.P.)",
  "375": "Classe d'Adaptation",
  "376": "Classe Spéciale Ecole Primaire",
  "377": "Etablissement Expérimental pour Enfance Handicapée",
  "378": "Etablissement Expérimental Enfance Protégée",
  "379": "Etablissement Expérimental pour Adultes Handicapés",
  "380": "Etablissement Expérimental Autres Adultes",
  "381": "Etablissement Expérimental pour Personnes Agées",
  "382": "Foyer de Vie pour Adultes Handicapés",
  "386": "Ecole Secondaire Spéciale",
  "390": "Etablissement d'Accueil Temporaire d'Enfants Handicapés",
  "393": "Autre résidence But lucratif pr personnes Âgées",
  "394": "Etablissement d'Accueil Temporaire pour Personnes Agées",
  "395": "Etablissement d'Accueil Temporaire pour Adultes Handicapés",
  "396": "Foyer Hébergement Enfants et Adolescents Handicapés",
  "397": "Service Auxiliaire de Vie pour Handicapés",
  "398": "Crèche Parentale",
  "399": "Halte Garderie Parentale",
  "400": "Centre de Services pour Associations",
  "401": "D.R.A.S.S.",
  "402": "Jardin d'Enfants Spécialisé",
  "403": "Service Social Spécialisé ou Polyvalent de Catégorie",
  "404": "Etablissement Acc.Collect.Parental Régulier & Occasionnel",
  "405": "Service Social Polyvalent de Secteur",
  "411": "Intermédiaire de Placement Social",
  "412": "Appartement Thérapeutique",
  "413": "C.E.C.O.S",
  "414": "Centre Anti Poison",
  "415": "Service Médico-Psychologique Régional (S.M.P.R.)",
  "418": "Service d'Enquêtes Sociales (S.E.S.)",
  "419": "Centre d'Accueil Toxicomanes",
  "420": "Entreprise d'Insertion",
  "421": "Centre d'enseignement aux secours d'urgence",
  "422": "Traitements Spécialisés à Domicile",
  "423": "Ecole des cadres de laborantins d'analyses médicales",
  "425": "Centre d'Accueil Thérapeutique à temps partiel (C.A.T.T.P.)",
  "426": "Syndicat Inter Hospitalier (S.I.H.)",
  "427": "Service Educatif Auprès des Tribunaux (S.E.A.T.)",
  "430": "Centre Postcure Malades Mentaux",
  "431": "Centre Postcure pour Alcooliques",
  "432": "Centre Postcure pour Toxicomanes",
  "433": "Etablissement Sanitaire des Prisons",
  "434": "Classe Spéciale en Ecole Maternelle",
  "435": "Centre de formation d'aide à domicile",
  "436": "Ecoles Formant aux Professions Sanitaires et Sociales",
  "437": "Foyer d'Accueil Médicalisé pour Adultes Handicapés (F.A.M.)",
  "438": "Centre de Médecine collective",
  "439": "Centre Santé Polyvalent",
  "440": "Service d’Investigation Educative",
  "441": "Service d’Intervention Educative en Milieu Ouvert",
  "442": "Centre Provisoire Hébergement (C.P.H.)",
  "443": "Centre Accueil Demandeurs Asile (C.A.D.A.)",
  "444": "Centre Crise Accueil Permanent",
  "445": "Service d'accompagnement médico-social adultes handicapés",
  "446": "Service d'Accompagnement à la Vie Sociale (S.A.V.S.)",
  "447": "Entreprise Intérim Insertion",
  "448": "Etab.Acc.Médicalisé en tout ou partie personnes handicapées",
  "449": "Etab.Accueil Non Médicalisé pour personnes handicapées",
  "450": "Service d'Aide aux Personnes Agées",
  "451": "Service d'Aide aux Familles en Difficulté",
  "452": "Régie de Quartier",
  "453": "Service de Réparation Pénale",
  "460": "Service autonomie aide (SAA)",
  "461": "Centres de Ressources S.A.I. (Sans Aucune Indication)",
  "462": "Lieux de Vie et d’Accueil",
  "463": "Centres Locaux Information Coordination P.A.(C.L.I.C.)",
  "464": "Unités Evaluation Réentraînement et d'Orient. Soc. et Pro.",
  "500": "Etablissement d'hébergement pour personnes âgées dépendantes",
  "501": "EHPA percevant des crédits d'assurance maladie",
  "502": "EHPA ne percevant pas des crédits d'assurance maladie",
  "601": "Cabinet Libéral Médical",
  "602": "Cabinet de Groupe",
  "603": "Maison de santé (L.6223-3)",
  "604": "Communauté Professionnelle Territoriale de Santé (CPTS)",
  "605": "Cabinet d'Auxiliaires Médicaux",
  "606": "Dispositif d'appui à la coordination (DAC)",
  "607": "Groupement Régional d'Appui au Développement de la e-Santé (GRADeS)",
  "608": "Equipe mobile médico-sociale précarité (EMMSP)",
  "609": "Maison Départementale pour Personnes Handicapées (MDPH)",
  "610": "Laboratoire d'Analyses",
  "611": "Laboratoire de Biologie Médicale",
  "612": "Autre Laboratoire de Biologie Médicale sans FSE",
  "614": "Dispositif Spécifique Régional du Cancer (DSRC)",
  "616": "Services de Prévention et de Santé au Travail (SPST)",
  "617": "Lieu de soins non programmés",
  "618": "Autre structure de soins non programmés (SNP)",
  "620": "Pharmacie d'Officine",
  "621": "Lunetterie Médicale",
  "622": "Centre d'Appareillage & Prothèse",
  "623": "Herboristerie",
  "624": "Laboratoire pharmaceutique préparant délivrant allergènes",
  "627": "Propharmacie",
  "628": "Pharmacie Minière",
  "629": "Pharmacie Mutualiste",
  "630": "Installation autonome de chirurgie esthétique",
  "631": "Maisons de naissance",
  "632": "Structure Dispensatrice à domicile d'Oxygène à usage médical",
  "633": "Structure Expérimentale en Santé",
  "636": "Centre de soins et de prévention",
  "637": "Centre de Lutte Antituberculeuse (CLAT)",
  "638": "Centre gratuit d'information de dépistage et de diagnostic (CeGIDD)",
  "639": "Sociétés de téléconsultation (STLC)",
  "640": "Service d'aide et d'accompagnement à domicile aux familles (SAADF)",
  "641": "Antenne de Pharmacie d'officine",
  "642": "Services départementaux d'incendie et de secours",
  "643": "Serv. d'éval de la minorité de l'isolement pour les pers. se déclarant mineures",
  "644": "Etab. de mise à l'abri pour les pers. se déclarant mineures non accompagnées",
  "645": "Centre de Vaccination",
  "646": "Centre de Vaccination Internationale",
  "647": "Equipe de Soins Spécialisés",
  "648": "Structure qui contribue au Service d'Accès aux Soins",
  "649": "Centre de santé et de médiation en santé sexuelle",
  "650": "Dispositifs Spécifiques Régionaux en périnatalité",
  "690": "Etablissement de Fabrication Annexe à une Officine",
  "695": "Groupement de coopération sanitaire de moyens - Exploitant",
  "696": "Groupement de coopération sanitaire de moyens",
  "697": "Groupement de coopération sanitaire - Etablissement de santé",
  "698": "Autre Etablissement Loi Hospitalière",
  "699": "Entité Ayant Autorisation",
  "700": "Maison sport-santé",
  "701": "Maison des adolescents (MDA)",
  "702": "Point Accueil Ecoute Jeunes (PAEJ)",
  "703": "Espace Santé Jeunes (ESJ)",
  "704": "Autre service territorial",
  "705": "Groupe d’Entraide Mutuelle (GEM)",
  "1000": "Etablissements Relevant de la Loi Hospitalière",
  "1100": "Etablissements Hospitaliers",
  "1101": "Centres Hospitaliers Régionaux",
  "1102": "Centres Hospitaliers",
  "1103": "Centres Hospitaliers Spécialisés Lutte Maladies Mentales",
  "1104": "Centres de Lutte contre le Cancer",
  "1106": "Hôpitaux Locaux",
  "1107": "Etablissements de santé privé autorisés en SSR",
  "1108": "Centre de Moyen et de Long Séjour",
  "1109": "Etablissements de Soins de Longue Durée",
  "1110": "Etablissements de Soins de Courte Durée",
  "1111": "Autres Etablissements de Lutte contre les Maladies Mentales",
  "1112": "Etablissements d'Enfants à Caractère Sanitaire",
  "1113": "Etablissements de Lutte contre l'Alcoolisme",
  "1200": "Autres Etablissements Relevant de la Loi Hospitalière",
  "1201": "Traitements et Soins à Domicile",
  "1202": "Santé Mentale",
  "1203": "Dialyse ambulatoire",
  "1204": "Urgence et Réanimation",
  "1205": "Autres Etablissements Relevant de la Loi Hospitalière",
  "2000": "Autres Etablissements de Soins et Prévention",
  "2100": "Cabinets Libéraux",
  "2101": "Cabinets Libéraux de Médecins",
  "2102": "Cabinet de Groupe",
  "2103": "Autres structures d'exercice libéral",
  "2105": "Cabinet d'Auxiliaires Médicaux",
  "2200": "Autres Etablissements de Soins et Prévention",
  "2201": "Dispensaires ou Centres de Soins",
  "2202": "Etablissements de PMI et de Planification Familiale",
  "2203": "Etablissements de Soins Dentaires",
  "2204": "Etablissements ne relevant pas de la Loi Hospitalière",
  "2205": "Etab.de soins relevant du service de santé des armées",
  "2206": "Centres de Santé",
  "3000": "Autres Etablissements à Caractère Sanitaire",
  "3100": "Laboratoires de Biologie Médicale",
  "3101": "Laboratoires de Biologie Médicale",
  "3200": "Commerce de Biens à Usage Médicaux",
  "3201": "Commerce de Biens à Usage Médicaux",
  "3202": "Commerce de Biens Médicaux",
  "3400": "Autres Etablissements à Caractère Sanitaire",
  "3401": "Transfusion Sanguine",
  "3402": "Conservation et Stockage d'autres Produits Humains",
  "3403": "Centre Antipoison",
  "3404": "Service d'Ambulances",
  "3405": "Installations autonomes de chirurgie esthétique",
  "3406": "Maisons de Naissance",
  "3407": "Etablissements Expérimentaux en Santé",
  "3408": "Centre de ressources transverse",
  "3409": "Services de Prévention et de Santé au Travail (SPST)",
  "3410": "Services d'incendie et de secours",
  "4000": "Etab.Serv.Soc.d'Accueil Hébergement Assistance Réadaptation",
  "4100": "Etab.et Serv.pour l'Enfance et la Jeunesse Handicapée",
  "4101": "Etab.Educ.Spéciale pour Déficients Mentaux et Handicapés",
  "4102": "Etab.Educ Spéciale pour Enfants Trouble Conduite et Comport",
  "4103": "Etablissements d'Education Spéciale pour Handicapés Moteurs",
  "4104": "Etab.Education Spéciale pour Déficients Sensoriels",
  "4105": "Etablissements et Services Hébergement Enfants Handicapés",
  "4106": "Services à Domicile ou Ambulatoires pour Handicapés",
  "4107": "Etab. Expérimentaux en Faveur de l'Enfance Handicapée",
  "4200": "Etablissements ou Classes d'Enseignement Spécial",
  "4201": "Etablissements ou Classes de Pré-Élémentaire et Élémentaire",
  "4202": "Etablissements d'Enseignement Secondaire",
  "4300": "Etablissements et Services pour Adultes Handicapés",
  "4301": "Etab. et Services d'Hébergement pour Adultes Handicapés",
  "4302": "Etab.et Services de Travail Protégé pour Adultes Handicapés",
  "4303": "Etab.et Services de Réinsertion Prof pour Adultes Handicapés",
  "4304": "Etab.Expérimentaux en Faveur des Adultes Handicapés",
  "4305": "Services de Maintien à Domicile pour Handicapés",
  "4400": "Etablissements et Services pour Personnes Agées",
  "4401": "Etablissements d'Hébergement pour Personnes Âgées",
  "4402": "Services de Maintien à Domicile pour Personnes Âgées",
  "4403": "Services Sociaux en Faveur des Personnes Âgées",
  "4404": "Etablissements Expérimentaux en Faveur des Personnes Âgées",
  "4500": "Etab.et Serv.Sociaux Concourant à la Protection de l'Enfance",
  "4501": "Etablissements de l'Aide Sociale à l'Enfance",
  "4502": "Etab.et Services du Ministère de la Justice pour Mineurs",
  "4504": "Services Concourant à la Protection de l'Enfance",
  "4505": "Etab. Expérimentaux en Faveur de l'Enfance Protégée",
  "4600": "Autres Etab. Accueil, Hébergement, Réadaptation et Services",
  "4601": "Etablissements pour Adultes et Familles en Difficulté",
  "4602": "Autres Etablissements Sociaux d'Hébergement et d'Accueil",
  "4603": "Etablissements Expérimentaux en Faveur des Adultes",
  "4604": "Autres Etablissements médico-sociaux",
  "4605": "Etablissements et services multi-clientèles",
  "4606": "Centres de ressources",
  "4607": "Logements en Structure Collective",
  "4608": "Protection des majeurs",
  "4609": "Centres prestataires de services pr personnes cérébro-lésées",
  "5000": "Etablissements et Services Sociaux d'Aide à la Famille",
  "5100": "Etablissements et Services Sociaux d'Aide à la Famille",
  "5101": "Etablissements Garde d'Enfants d'Age pré-Scolaire",
  "5102": "Etablissements d'Hébergement pour Enfants d'Age Scolaire",
  "5103": "Etablissements Sociaux pour Loisirs et Vacances",
  "5104": "Etablissements ou Services Divers d'Aide à la Famille",
  "6000": "Etab.de Formation des Personnels Sanitaires et Sociaux",
  "6100": "Etablissements de Formation des Personnels Sanitaires",
  "6101": "Etablissements de Formation des Personnels Sanitaires",
  "6102": "Etablissements de Formation des Personnels Techniques",
  "6103": "Autres Etablissements de Formation des Personnels Techniques",
  "6200": "Etablissements de Formation des Personnels Sociaux",
  "6201": "Etablissements de Formation des Personnels Sociaux",
  "6300": "Etablissements de Formation Polyvalente",
  "6301": "Etablissements de Formation Polyvalente",
  "0100": "Etablissements d'administration",
  "0110": "Etablissements d'Administration",
  "0101": "Etablissements d'Administration",
  "001": "Autres lits de m.R.",
  "002": "Autres places de l-f.",
  "003": "Autres lits de l-s",
} as const satisfies Record<string, string>;
